<template>
  <div class="main">
    Not found
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>



// WEBPACK FOOTER //
// src/errors/NotFound.vue